module.exports = __webpack_public_path__ + "static/img/six4.fbe9906.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/six4.png
// module id = zq3u
// module chunks = 25